// app/javascript/projects/index.js
import 'babel-polyfill';
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

const projects = document.querySelector('#projects')
createRoot(projects).render(<App />)
